import React, { useEffect, useState } from 'react';
import { Field } from 'formik';
import Status from './../../../../TopQualities/status.jsx';
import UploadMediaWithS3 from 'components/HOCs/UploadMediaWithS3';
import MediaInput from 'components/HOCs/MediaInput/MediaInput.jsx';
import style from './style.module.scss';

const FileInput = ({
  name,
  label,
  isRequired = false,
  resetUpload = false,
  isFullWidth = false,
  ...restProps
}) => {
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (resetUpload) {
      setResetKey((prev) => prev + 1);
    }
  }, [resetUpload]);

  return (
    <Field name={name}>
      {({ field, meta: { error, touched }, form }) => {
        return (
          <div className={style['input-wrapper']}>
            {label && (
              <div className={style.label}>
                <span>{label}</span>
                {isRequired && <Status isFilled={!error && !!field?.value} />}
              </div>
            )}

            <div className={style['box']}>
              <MediaInput
                key={resetKey}
                name={name}
                label={null}
                isRequired={isRequired}
                isFullWidth={isFullWidth}
                {...restProps}
              />
            </div>

            {isRequired && touched && !field.value && (
              <p className={style.error}>{form.errors[name]}</p>
            )}
          </div>
        );
      }}
    </Field>
  );
};

export default FileInput;
